const Accordion = {
  baseStyle: {
    button: {
      _hover: {
        background: "initial",
      },
    },
  },
};

export default Accordion;
